import React from 'react'

const GroupCreateFormView = () => {
  return (
    <div>GroupCreateFormView</div>
  )
}

export default GroupCreateFormView